import LinkOrElement from './LinkOrElement';

export { type LinkOrElementProps } from './LinkOrElement';
export default LinkOrElement;
